import React from 'react';
import './StepperComponent.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {Box} from '@mui/material';
import {ReactComponent as Next} from '../../../../../assets/images/icon-right-outline.svg';
import {ReactComponent as Tick} from '../../../../../assets/images/green-tick-icon-outline.svg';

export interface Step {
  key: number;
  label: string;
  state: 'completed' | 'current' | 'future';
}

export interface StepperProps {
  steps: Step[];
  currentStepKey: number;
  onStepChange?: (key: number) => void;
  allowNonLinear?: boolean;
  clickableSteps?: boolean;
}

export const StepperComponent: React.FC<StepperProps> = ({
  steps,
  onStepChange,
  allowNonLinear = false,
}) => {
  const handleStepClick = (step: Step) => {
    if (!allowNonLinear && step.state === 'future') return;
    if (step.state !== 'current' && onStepChange) onStepChange(step.key);
  };

  const getStepPositionClass = (index: number) => {
    if (index === 0) return 'first';
    if (index === steps.length - 1) return 'last';
    return 'middle';
  };

  return (
    <Box
      role="tablist"
      aria-label="Stepper"
      className="ar-review-stepper-container"
    >
      {steps.map((step, index) => (
        <ArrButton
          key={step.key}
          onClick={() => handleStepClick(step)}
          disabled={step.state === 'completed'}
          role="tab"
          aria-current={step.state === 'current' ? 'step' : undefined}
          aria-disabled={step.state === 'completed'}
          className={`step ${step.state} ${getStepPositionClass(index)}`}
          endIcon={
            index !== steps.length - 1 && (
              <Next className="chev-right-icon" data-testid="chev-right-icon" />
            )
          }
          dataTestId={`stepper-component-button-${step.key}`}
        >
          <span
            className="stepper-label"
            data-testid={`stepper-component-span-${index}`}
          >
            {step.label}
            {step.state === 'completed' ? (
              <Tick className="step-check-icon" />
            ) : null}
          </span>
        </ArrButton>
      ))}
    </Box>
  );
};
